export default __webpack_public_path__ + "static/media/arduino.ea744640.svg";